import Appsignal from "@appsignal/javascript";

const key = process.env.REACT_APP_APPSIGNAL_KEY;

export default key != null ? new Appsignal({
    key: process.env.REACT_APP_APPSIGNAL_KEY,
    revision: process.env.REACT_APP_REVISION
}) : null;
